import React from 'react';
import './OtpBoxLogin.css';
import {connect} from 'react-redux';
import * as actionTypes from '../../../../Action/Index';

import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner'
import VerifyEmailAfterLoginModal from '../../VerifyEmailAfterLogin/VerifyEmailAfterLogin';
class OtpBox extends React.Component{

    state = {
        length: 0,
        otp1:'',
        otp2:'',
        otp3:'',
        otp4:'',
        otpLength: 4
      
    }

    emptyFields = () => {
        this.otp1.value = ''
        this.otp2.value = ''
        this.otp3.value = ''
        this.otp4.value = ''
    }
    // emptystate=()=>{
    //     this.setState({length: 0,
    //         otp1:'',
    //         otp2:'',
    //         otp3:'',
    //         otp4:'',})
    // }
    componentWillReceiveProps(nextProps){
         if(nextProps.mobileLastFourDigit!==""){
             this.setState({mobileLastFourDigit:nextProps.mobileLastFourDigit})
         }

        if(nextProps.OTPverified === 'NO' && this.otp1.value !== ''){
            // this.setState({
            //     otp1:'',
            //     otp2:'',
            //     otp3:'',
            //     otp4:'',
            //     length:0,
               
            // })
            this.emptyFields()
        }
    }

    keyFinder = (keys)=>{
        if(keys===48){return 0}
        if(keys===49){return 1}
        if(keys===50){return 2}
        if(keys===51){return 3}
        if(keys===52){return 4}
        if(keys===53){return 5}
        if(keys===54){return 6}
        if(keys===55){return 7}
        if(keys===56){return 8}
        if(keys===57){return 9}
    }
    changeFocus = (e)=>{

        var value = this.keyFinder(e.keyCode)
        if(value===undefined && e.keyCode!==8){
            return
        }
            if(e.keyCode==8){
                console.log('keycode', e.target.name)
                        if(e.target.name === 'otp4'){
                            e.target.value = ''
                            // if(this.state.length > 0)
                            this.otp4.value = ''
                            this.otp3.focus()
                        }
                        if(e.target.name === 'otp3'){
                            e.target.value = ''
                            // if(this.state.length > 0)
                            this.otp3.value = ''
                            this.otp2.focus()
                            // this.otp2.focus()
                        }
                        if(e.target.name === 'otp2'){
                            e.target.value = ''
                            // if(this.state.length > 0)
                            this.otp2.value = ''
                            this.otp1.focus()
                        }
                
                        if(e.target.name === 'otp1'){
                            e.target.value = ''
                            // if(this.state.length > 0)
                            this.otp1.value = ''
                        }
            }
            if(e.keyCode!=8){ 
                    if(e.target.name === 'otp1'&& this.state.otp1===""){
                        this.otp1.value = value
                       this.otp2.focus()
                     }
                    if(e.target.name === 'otp2' && this.state.otp2===""){
                        this.otp2.value = value
                        this.otp3.focus()
                    }
                    if(e.target.name === 'otp3'&& this.state.otp3===""){
                        this.otp3.value = value
                        this.otp4.focus()
                    }
                    if(e.target.name === 'otp4'&& this.state.otp4===""){
                        this.otp4.value = value
                    }
                    if(e.target.name === 'otp1'&& this.state.otp1!==""){
                        this.otp2.value = value
                        this.otp2.focus(); 
                    }
                    if(e.target.name === 'otp2'&& this.state.otp2!==""){
                        this.otp3.value = value
                        this.otp3.focus(); 
                    }
                    if(e.target.name === 'otp3'&& this.state.otp3!==""){
                       this.otp4.value = value
                       this.otp4.focus(); 
                    }
            }
    }
   
    VerifyOtp=()=>{
        if( !!this.otp1.value + !!this.otp2.value + !!this.otp3.value + !!this.otp4.value < 4){
            this.setState({
                otpLength: -1
            })
            return
        }
        else {
            this.setState({
                otpLength: 4
            })
        }
        let otp={
            o1:this.otp1.value,
            o2:this.otp2.value,
            o3:this.otp3.value,
            o4:this.otp4.value,
        }
      let arr=  Object.keys(otp).map((id)=>{
           return otp[id]
      })
      let str=arr.join("");
        this.props.verifyOtpMethode(this.props.email,str);
       
    }
    resendOTP=()=>{
    this.props.resendOTP(this.props.email)
    this.setState({
        otp1: '',
        otp2: '',
        otp3: '',
        otp4: ''
    })
    this.otp1.value = ''
    this.otp2.value = ''
    this.otp3.value = ''
    this.otp4.value = ''
   }
   
 render(){
     let mobileLastFourDigit=this.props.mobileNumber.substring(6,10)

     console.log(this.props.resendotpLoader, this.props.verifyotpAtloginLoader)
     if(this.props.open===true){
    return (
        this.props.verifyotpAtloginApiStatus ?
        <VerifyEmailAfterLoginModal 
        email={this.props.email}
        closeModal={this.props.closeModal}
        />
        // <SweetAlert email={this.props.email}  ErrorCode={this.props.ErrorCode} closeModal={this.props.closeModal} type="success" show="true" msg="Mobile Verified Successfully"/>
        :
        <div className="otp-modal-form">
        <Loader show={this.props.resendotpLoader || this.props.verifyotpAtloginLoader} message={ <Spinner animation="border" role="status"></Spinner> } style={{height:"auto"}}
        foregroundStyle={{color: '#fbb03b'}}
        backgroundStyle={{backgroundColor: '#F3EFEF'}}
        >
                <div className="" style={{width:'100%',display:'flex'}}>
                    <div className="modal-title">
                        <span style={{marginLeft:'50px'}}>Verify Mobile Number</span>
                    </div>
                   
                </div>
                 
                    <div className="success-msg">
                       {(this.props.verifyotpAtloginerrorMsg === '' || this.props.verifyotpAtloginerrorMsg === undefined)?
                        <span>
                        Please verify your Mobile Number to proceed.<br/>
                        We have sent an OTP to your registered Mobile Number.
                        </span>
                      :null
                       } 

                    </div>
                    <div className="success-msg">
                        {(this.props.verifyotpAtloginerrorMsg !== '')?
                            <>
                                <span style={{color: 'red'}}>Wrong OTP</span><br/>
                                <span>Please re-enter the OTP</span>
                            </>
                            : null
                        }
                    </div>
                    <div className="success-msg">
                        {(this.state.otpLength < 4)?
                            <>
                                <span>Please Enter the OTP</span>
                                <span>&nbsp;</span>
                            </>
                            : null
                        }
                    </div>
                
                <div>    
                    <div className="modal-input">
                        <span className="">
                            <input 
                                type="number" 
                                name="otp1"
                                autoComplete='off'
                                
                                defaultValue={this.state.otp1}
                                ref={el => this.otp1 = el} 
                                onKeyUp={(e)=>this.changeFocus(e)}
                                maxLength="1"
                                style={{textAlign:'center',width:"30px"}}
                             />
                        </span>
                        <span className="">
                            <input 
                                type="number"  
                                name="otp2"
                                autoComplete='off'
                                defaultValue={this.state.otp2}
                                ref={el => this.otp2 = el} 
                                onKeyUp={(e)=>this.changeFocus(e)}
                                maxLength="1"
                                style={{textAlign:'center',width:"30px"}}/>
                        </span>
                        <span className="">
                            <input 
                                 type="number" 
                                 name="otp3"
                                 autoComplete='off'
                                 defaultValue={this.state.otp3}
                                 ref={el => this.otp3 = el} 
                                 onKeyUp={(e)=>this.changeFocus(e)}
                                 maxLength="1"
                                 style={{textAlign:'center',width:"30px"}}/>
                        </span>
                        <span className="">
                            <input 
                                type="number"  
                                name="otp4"
                                autoComplete='off'
                                defaultValue={this.state.otp4}
                                ref={el => this.otp4 = el} 
                                onKeyUp={(e)=>this.changeFocus(e)}
                                maxLength="1"
                                style={{textAlign:'center',width:"30px"}}/>
                        </span>
                    </div>
                    <div className="resend" style={{width:'100%',textAlign:'center',marginTop:'30px'}}>
                    <button  style={{background:'white',color:'orange',height:32,width:'20%',borderRadius:20,marginLeft:0,border:"1px solid orange",fontWeight:"bold"}}
                    onClick={()=>this.props.closeModal()}
                    >Back</button>
                   
                    <button  style={{background:'#fbb03b',color:'#fff',height:32,width:'20%',borderRadius:20,marginLeft:23,border:"none" ,fontWeight:"bold"}} onClick={()=>this.VerifyOtp()}>Verify</button>
                    {/* <span className="verifyspinner">{this.props.verifyotpAtloginLoader || this.props.resendotpLoader ?<Spinner animation="border" variant="warning" />:null}</span> */}
                    <br/>
                        <div style={{marginTop:"25px"}} className="resendVerify">Didn't receive an OTP? <span style={{color:'#fbb03b',cursor:'pointer',fontWeight:"bold"}} onClick={()=>{this.resendOTP() }}>Resend</span></div>
                    </div>
                </div>
             </Loader>
        </div>
  )
    }else{
        return null;
    }
 }
  
}


const mapStateToProps = state => {
    console.log(state.employeeReducer.verifyotpAtloginerrorMsg === '')
    return{
        verifyotpAtloginLoader:state.employeeReducer.verifyotpAtloginLoader,
        verifyotpAtloginApiStatus:state.employeeReducer.verifyotpAtloginApiStatus,
        verifyotpAtloginNetworkError:state.employeeReducer.verifyotpAtloginNetworkError,
        verifyotpAtloginerrorMsg:state.employeeReducer.verifyotpAtloginerrorMsg,
        resendotpLoader:state.employeeReducer.resendotpLoader,
        otpSent:state.employeeReducer.otpSent,
        mobileLastFourDigit:state.employeeReducer.mobileLastFourDigit,
        resendotpApiStatus:state.employeeReducer.resendotpApiStatus,
        resentNetworkError:state.employeeReducer.resentNetworkError,
        resentOtp:state.employeeReducer.resentOtp
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return{
        verifyOtpMethode: (email,data) => dispatch(actionTypes.verifyOtpAtlogin(email,data)),
        resendOTP:(email)=>dispatch(actionTypes.resendOTP(email)),
    }
  }
  
export default connect(mapStateToProps,mapDispatchToProps)(OtpBox);